import validate from "/home/forge/app.inaia.finance/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/forge/app.inaia.finance/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/forge/app.inaia.finance/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  protected: () => import("/home/forge/app.inaia.finance/middleware/protected.ts"),
  "upvest-activated": () => import("/home/forge/app.inaia.finance/middleware/upvest.activated.ts"),
  verified: () => import("/home/forge/app.inaia.finance/middleware/verified.ts")
}